import type { PurchasePaymentQueryParams } from "../../../../common/types/purchasePayment";
import type { Page } from "../../../../common/types/base/BaseEntity";
import { SIGN_ORIGIN } from "../../../../common/enum/common";
import { BaseService } from "./baseService";
import httpRequest from ".";
import type { PurchasePayment, PurchasePaymentVo } from "@zhihaoscm/entity";

export class PurchasePaymentService extends BaseService<
    PurchasePayment,
    PurchasePaymentVo,
    PurchasePaymentQueryParams,
    any
> {
    /**
     * 分页查询
     * @param params
     */
    async paging(params: PurchasePaymentQueryParams): Promise<Page<PurchasePaymentVo>> {
        const { data } = await this.service.get(`${this.path}/custom-paging`, { params });
        return data;
    }

    async getListByProjectId(
        projectId: number,
        type: number,
        params?: PurchasePaymentQueryParams
    ): Promise<PurchasePayment[]> {
        const { data } = await this.service.get(`${this.path}/paging/project-id/${projectId}/type/${type}`, { params });
        return data as Promise<PurchasePayment[]>;
    }

    /** 签署 */
    async sign(id: string): Promise<any> {
        const { data } = await this.service.put(`${this.path}/signing/${id}?origin=${SIGN_ORIGIN.PC.code}`);
        return data;
    }

    /**
     * 删除实例
     * @param id
     */
    public async delete(id: number | string) {
        const { data } = await this.service.delete(`${this.path}/${id}`);
        return data;
    }

    updateState(
        id: string | number,
        state: number,
        form?: {
            reason: string;
        }
    ) {
        let url = `${this.path}/update/${id}/state/${state}`;
        form?.reason && (url += `?reason=${form?.reason}`);
        return this.service.put(url);
    }

    reject(
        id: string | number,
        state: number,
        form?: {
            reason: string;
        }
    ) {
        let url = `${this.path}/update/${id}/state/${state}`;
        form?.reason && (url += `?reason=${form?.reason}`);
        return this.service.put(url);
    }

    /**
     * 创建实例
     * @param form
     */
    public async create(form: any): Promise<any> {
        for (const key in form) {
            const value = form[key];
            if (value === undefined || value === null || value === "") {
                delete form[key];
            }
        }
        const { data } = await this.service.post(this.path, form, {
            loading: true
        });
        return data;
    }

    /**
     * 更新实例
     * @param id
     * @param form
     */
    public async update(id: number | string, form: any) {
        const { data } = await this.service.put(`${this.path}/${id}`, form, {
            loading: true
        });
        return data;
    }

    /**作废发起流程(只有付款单位才能发起作废) */
    public async startInvalid(id: number) {
        const { data } = await this.service.put(
            `${this.path}/invalidSend/${id}`,
            {},
            {
                loading: true
            }
        );
        return data;
    }

    /**作废确认流程（确认作废） */
    public async agreeInvalid(id: number) {
        const { data } = await this.service.put(
            `${this.path}/invalidConfirm/${id}/1`,
            {},
            {
                loading: true
            }
        );
        return data;
    }

    /**作废确认流程（驳回） */
    public async rejectInvalid(id: number) {
        const { data } = await this.service.put(
            `${this.path}/invalidConfirm/${id}/0`,
            {},
            {
                loading: true
            }
        );
        return data;
    }
}

export const purchasePaymentService = new PurchasePaymentService("/purchase/payment", httpRequest);
